/* ChasingCards — „In den Warenkorb" auf Produktkarten (cc-pcard__cart).
   Globale Click-Delegation (wie cc-wishlist.js) — greift auch für nachgeladene
   Karten (Facets-/„Mehr laden"-AJAX). Spiegelt die Add-/Re-Render-Mechanik der
   Warenkorb-Empfehlungen (cart-recommendations.js, Regel 7): POST /cart/add mit
   sections -> Dawns cart-drawer.renderContents(state).

   Kernregel: Der Drawer öffnet NUR, wenn der Warenkorb vorher LEER war (0->1).
   Bei weiteren Produkten: stiller Re-Render (Badge + Drawer-Inhalt frisch), aber
   Drawer bleibt zu. Umgesetzt, indem für den stillen Pfad Dawns open() temporär
   neutralisiert wird (try/finally-sicher) — so bleiben Section-Update, Overlay-
   Relisten und is-empty-Handling 1:1 Dawns Logik; cart-drawer.js unangetastet.

   Der >1-Varianten-Fall wird serverseitig als <a> zur PDP gerendert (kein
   data-cc-add) und von diesem Handler ignoriert — der Link navigiert normal. */
(function () {
  'use strict';

  var ADD_SELECTOR = '.cc-pcard__cart[data-cc-add]';
  var FEEDBACK_MS = 1200;

  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  /* „War der Warenkorb leer?" — Präsenz der .cart-count-bubble-DIV prüfen, NICHT
     des inneren <span> (der fehlt bei >=100 Artikeln). div fehlt = leer (0);
     div da = >=1. Das Bubble wird bei jedem Add re-rendert -> bleibt korrekt. */
  function cartWasEmpty() {
    return !document.querySelector('#cart-icon-bubble .cart-count-bubble');
  }

  function addUrl() {
    if (window.routes && window.routes.cart_add_url) return window.routes.cart_add_url;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'cart/add';
  }

  function sectionsParam(drawer) {
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      return drawer
        .getSectionsToRender()
        .map(function (s) { return s.id; })
        .join(',');
    }
    return 'cart-icon-bubble';
  }

  function publishCartUpdate(state, variantId) {
    if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
      window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
        source: 'cc-card-cart',
        productVariantId: variantId,
        cartData: state,
      });
    }
  }

  /* Stiller Re-Render: Dawns renderContents nutzen (Section-Update + Overlay-
     Relisten + is-empty), aber das Öffnen unterdrücken.

     WICHTIG: renderContents ruft open() DEFERRED in einem setTimeout auf (nicht
     synchron). Ein synchrones try/finally würde open() also VOR dem deferred
     Aufruf wiederherstellen -> der Drawer öffnete doch. Deshalb ein EINMAL-
     Override, der sich beim (deferred) Aufruf SELBST wiederherstellt und das
     Öffnen schluckt. Dawns setTimeout re-bindet den Overlay-Listener VOR open()
     -> das bleibt erhalten (Regel 7). Bei synchronem Fehler in renderContents
     wird open() nie deferred -> catch stellt garantiert wieder her. */
  function renderSilently(drawer, state) {
    var realOpen = drawer.open;
    var restore = function () { drawer.open = realOpen; };
    drawer.open = function () { restore(); }; /* Einmal-Noop, self-restore, kein open */
    try {
      drawer.renderContents(state);
    } catch (e) {
      restore(); /* synchroner Fehler -> deferred open kommt nie -> jetzt wiederherstellen */
      throw e;
    }
  }

  /* Fallback ohne Drawer (cart_type != drawer): nur das Header-Bubble ziehen. */
  function updateBubbleOnly(state) {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble || !state.sections || !state.sections['cart-icon-bubble']) return;
    var doc = new DOMParser().parseFromString(state.sections['cart-icon-bubble'], 'text/html');
    var section = doc.querySelector('.shopify-section');
    bubble.innerHTML = section ? section.innerHTML : (doc.body ? doc.body.innerHTML : bubble.innerHTML);
  }

  function showFeedback(button) {
    button.classList.add('is-added');
    if (button._ccFbTimer) clearTimeout(button._ccFbTimer);
    button._ccFbTimer = setTimeout(function () {
      button.classList.remove('is-added');
      button._ccFbTimer = null;
    }, FEEDBACK_MS);
  }

  function lock(button) {
    button.classList.add('is-loading');
    button.setAttribute('aria-disabled', 'true'); /* CSS: pointer-events none -> Doppelklick-Schutz */
  }
  function unlock(button) {
    button.classList.remove('is-loading');
    button.removeAttribute('aria-disabled');
  }

  function addToCart(button) {
    var variantId = button.getAttribute('data-cc-add');
    if (!variantId) return;
    if (button.classList.contains('is-loading')) return; /* Doppelklick-Schutz (JS-Ebene) */

    lock(button);
    var drawer = getDrawer();
    var wasEmpty = cartWasEmpty(); /* VOR dem Add lesen */

    fetch(addUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: sectionsParam(drawer),
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) { return response.json(); })
      .then(function (state) {
        /* Fehler-Branch VOR jedem Drawer-Zugriff (Shopify liefert 422-Add-Fehler
           als JSON mit status/description). Button wieder freigeben, kein Drawer. */
        if (state.status) {
          unlock(button);
          return;
        }
        unlock(button);
        showFeedback(button);

        if (drawer && typeof drawer.renderContents === 'function') {
          /* Warenkorb ist nach dem Add nicht mehr leer -> is-empty am äußeren
             <cart-drawer> entfernen (spiegelt Dawns product-form.js:115). Sonst
             bleiben die Empty-State-Regeln aktiv: Produktzeile versteckt, Free-
             Shipping-Balken mittig. Steht bewusst NUR im Erfolgspfad (nach dem
             state.status-Fehler-Check) -> bei fehlgeschlagenem Add bleibt der
             leere Warenkorb korrekt is-empty. Vor renderContents, damit open()
             gleich den richtigen Focus-Container (nicht den Empty-State) wählt. */
          drawer.classList.remove('is-empty');
          if (wasEmpty) {
            drawer.renderContents(state); /* re-rendert Balken/Summe/Empfehlungen + ÖFFNET */
          } else {
            renderSilently(drawer, state); /* re-rendert, Drawer bleibt ZU */
          }
        } else {
          updateBubbleOnly(state);
        }
        publishCartUpdate(state, variantId);
      })
      .catch(function () {
        unlock(button); /* Netzfehler: Button freigeben, kein Drawer */
      });
  }

  document.addEventListener('click', function (e) {
    var button = e.target && e.target.closest ? e.target.closest(ADD_SELECTOR) : null;
    if (!button) return;
    /* Karte ist ein ganzflächiger Link — der Add-Klick darf NICHT die PDP
       auslösen. Button ist Geschwister des <a> (nicht verschachtelt); Propagation
       trotzdem stoppen (Gürtel + Hosenträger, wie beim Herz). */
    e.preventDefault();
    e.stopPropagation();
    addToCart(button);
  });
})();
